/* unplugin-vue-components disabled */import { render } from "./mask.vue?vue&type=template&id=624f35c8&scoped=true"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"

import "./mask.vue?vue&type=style&index=0&id=624f35c8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624f35c8"],['__file',"src/controls/mask.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "624f35c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('624f35c8', __exports__)) {
    api.reload('624f35c8', __exports__)
  }
  
  module.hot.accept("./mask.vue?vue&type=template&id=624f35c8&scoped=true", () => {
    api.rerender('624f35c8', render)
  })

}


export default __exports__